const frequency = [
  'Hourly',
  'Weekly',
  'Bi-weekly',
  'Monthly',
];

export default frequency;
